import React from 'react'
import styled, { css } from 'styled-components'
import { string, node } from 'prop-types'
import { stripUnit } from 'polished'

import * as spacing from 'styles/spacing'
import { H3, fontWeights } from 'styles/typography'
import { media } from 'styles/media'
import { greyDark } from 'styles/colors'

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: ${spacing.large};

  ${media.medium`
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.large`
    margin-bottom: ${spacing.xxLarge};
  `};

  ${media.xLarge`
    margin-bottom: ${spacing.xxxLarge};
  `};
`

const Chapter = styled.div`
  position: relative;
  margin-right: ${spacing.large};
  padding-right: ${stripUnit(spacing.medium) * 1.25 + 'px'};

  ${props =>
    props.isBack &&
    css`
      ${media.medium`
      margin-top: 2px;
    `};

      ${media.large`
      margin-top: 4px;
    `};
    `}

  &:after {
    content: '';
    position: absolute;
    width: 2px;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    height: 18px;
    background-color: ${greyDark};
  }
`

const Main = styled.main`
  flex: 1;
`

const Number = styled(H3)`
  font-weight: ${fontWeights.medium};
`

const Title = styled(H3)`
  font-weight: ${fontWeights.regular};
`

const Heading = ({ number, title, description, back, mobileBack }) => {
  const BackComponent = back
  const MobileBack = mobileBack

  return (
    <Container>
      {number && (
        <Chapter>
          <Number>{number}</Number>
        </Chapter>
      )}
      {back && (
        <Chapter isBack={back}>
          <BackComponent />
        </Chapter>
      )}
      <Main>
        <Title>{title}</Title>
        {description && <p>{description}</p>}
      </Main>
      {mobileBack && <MobileBack />}
    </Container>
  )
}

Heading.propTypes = {
  number: string,
  title: string,
  description: string,
  back: node,
  mobileBack: node
}

export default Heading
